import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'tasks-multiline-text',
  standalone: true,
  imports: [],
  templateUrl: './multiline-text.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class MultilineTextComponent {
  text = input.required<string>();

  protected readonly lines = computed(() => this.text().split('\n'));
}
